module.exports = __webpack_public_path__ + "media/dominican.57ff59f3.png";